require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/registrer/videoFloorRegistrer.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/registrer/videoFloorRegistrer.legacy.js
// module id = 724
// module chunks = 31